/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled from 'styled-components'
import { SmallHeading } from '../../../../buildingBlocks'

interface DesktopSearchMenuProps {
  heading: string
}

export const DesktopSearchMenu: React.FC<React.PropsWithChildren<DesktopSearchMenuProps>> = ({ heading, children }) => (
  <Container>
    <Sidebar>
      <SmallHeading>{heading}</SmallHeading>
      <Body>{children}</Body>
    </Sidebar>
  </Container>
)

const Container = styled.div`
  box-shadow: 8px 0 12px 0 rgba(0, 0, 0, 0.05);
  margin-right: 2rem;
`

const Sidebar = styled.div`
  align-items: center;
  width: 30rem;
  transition: width 300ms;
  padding: 3.5rem 2rem 2rem;
  box-sizing: border-box;
`
const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem 0 6rem 0rem;
`
